import { render } from "./AppBarComponent.vue?vue&type=template&id=a79e504c&ts=true"
import script from "./AppBarComponent.vue?vue&type=script&lang=ts"
export * from "./AppBarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__